// src/services/subscriptionUserService.js
import apiClient from './apiClient';

const subscriptionUserService = {
  // Crear una nueva suscripción de usuario
  createSubscriptionUser: async (subscriptionData) => {
    try {
      console.log('Creating user subscription:', JSON.stringify(subscriptionData, null, 2));
      const response = await apiClient.post('/subscriptionUsers/', subscriptionData);
      console.log('Subscription created response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating subscription:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener todas las suscripciones de un usuario
  getUserSubscriptions: async (idCard) => {
    try {
      const response = await apiClient.get(`/subscriptionUsers/user?idCard=${idCard}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting subscriptions for user ${idCard}:`, error);
      throw error;
    }
  },

  // Obtener la suscripción activa de un usuario
  getActiveSubscription: async (idCard) => {
    try {
      const response = await apiClient.get(`/subscriptionUsers/active?idCard=${idCard}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting active subscription for user ${idCard}:`, error);
      throw error;
    }
  },

  // Renovar una suscripción
  renewSubscription: async (subscriptionId, renewalData) => {
    try {
      console.log('Renewing subscription:', subscriptionId, renewalData);
      const response = await apiClient.put(`/subscriptionUsers/renew/${subscriptionId}`, renewalData);
      console.log('Subscription renewed response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error renewing subscription ${subscriptionId}:`, error);
      throw error;
    }
  },

  // Cancelar una suscripción
  cancelSubscription: async (subscriptionId) => {
    try {
      const response = await apiClient.delete(`/subscriptionUsers/cancel/${subscriptionId}`);
      return response.data;
    } catch (error) {
      console.error(`Error canceling subscription ${subscriptionId}:`, error);
      throw error;
    }
  },

  // Obtener suscripciones de usuario por ID de parqueo
  getUserSubscriptionsByParkingId: async (parkingId, idCard) => {
    try {
      const response = await apiClient.get(`/subscriptionUsers/getUserSubscriptionsByParkingId?parkingId=${parkingId}&idCard=${idCard}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting subscriptions for parking ${parkingId}:`, error);
      throw error;
    }
  },

  // Verificar si un usuario tiene suscripción activa
  hasActiveSubscription: async (idCard) => {
    try {
      const response = await this.getActiveSubscription(idCard);
      return response && response.expiration && new Date(response.expiration) > new Date();
    } catch (error) {
      // Si no se encuentra suscripción activa, retornar false
      return false;
    }
  },

  // Obtener detalles completos de suscripción (con información del plan)
  getSubscriptionDetails: async (subscriptionUserId) => {
    try {
      const response = await apiClient.get(`/subscriptionUsers/${subscriptionUserId}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting subscription details ${subscriptionUserId}:`, error);
      throw error;
    }
  }
};

export default subscriptionUserService;